export default __webpack_public_path__ + "static/media/wetez_staking_node.1268ca29.svg";